// api.js

import axiosInstance from "../axiosInstance";

export const forecastParameterService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/forecast-parameter", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/forecast-parameter?&$limit=${limit || 15}&$skip=${skip || 0}&${
          searchValue ? `&name[$search]=${searchValue}` : ""
        }`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(
        `/forecast-parameter/${id}`,
        obj,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/forecast-parameter/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/forecast-parameter/${id}`);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
};
